export default __webpack_public_path__ + "static/team-05f1cfdd867bd0f6b465d3c035d6afeb.svg";